import React from "react";
import { Navigate } from "react-router-dom";

/** Check-in is started from Yard Operations (Actions → Check In). */
const AppointmentCheckInView = () => (
  <Navigate to="/dashboard/yard-management" replace />
);

export default AppointmentCheckInView;
